import styled, { DefaultTheme, SimpleInterpolation, ThemedStyledProps } from 'styled-components';

import { Button, ButtonVariant } from '@dreryk/react-components';
import { assertUnreachable } from '@dreryk/react-common';

const resolveColor = (
   props: ThemedStyledProps<{ variant: ButtonVariant | undefined }, DefaultTheme>
): SimpleInterpolation => {
   switch (props.variant) {
      case ButtonVariant.PRIMARY:
         return `
               background: ${props.theme.error};
               border-color: ${props.theme.error};
               &:not(:disabled):hover {
                   background: ${props.theme.errorDark};
                   border-color: ${props.theme.errorDark};
               }
            `;
      case ButtonVariant.SECONDARY:
         return `
               color: ${props.theme.error};
               border-color: ${props.theme.error};
               &:not(:disabled):hover {
                   color: ${props.theme.white};
                   border-color: ${props.theme.errorDark};
                   background: ${props.theme.errorDark};
               }
            `;
      default:
         return assertUnreachable(props.variant);
   }
};

export const StyledEmergencyButton = styled(Button)`
   ${resolveColor};
`;
